import { API_BASE_OPERATOR, STORAGE_KEYS, isCapacitorRuntime } from "../config/vars";

function getStoredAccessToken() {
    if (!isCapacitorRuntime()) return null;
    try {
        return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    } catch (_) {
        return null;
    }
}

function _getPath(input) {
    if (typeof input !== "string") return "";
    try {
        return new URL(input, window.location.origin).pathname;
    } catch (_) {
        return input;
    }
}

function shouldSkipRefresh(input) {
    const path = _getPath(input);
    if (!path.includes("/login/")) return false;

    // Avoid refresh loops or unnecessary refresh attempts.
    if (path.endsWith("/login/refresh")) return true;
    if (path.endsWith("/login/logout")) return true;

    // Skip refresh for actual login endpoints (but NOT /login/me).
    return /\/login\/(admin|operator|client)(\/verify-code)?$/.test(path);
}

export async function apiFetch(input, init = {}, options = {}) {
    const { retryOn401 = true } = options;

    const bearer = getStoredAccessToken();
    const headers = new Headers(init?.headers || undefined);
    if (bearer) {
        // Mobile fallback: cookies may not persist to 10.0.2.2 / cross-origin.
        headers.set("Authorization", `Bearer ${bearer}`);
    }

    const res = await fetch(input, {
        ...init,
        headers,
        credentials: "include",
    });

    // License enforcement: backend returns 402 when license is missing/expired.
    // Emit a global event so the app can show an informative banner/screen.
    if (res.status === 402) {
        try {
            window.dispatchEvent(new CustomEvent("licenseBlocked"));
        } catch (_) {
            // ignore
        }
    }

    // If we're using Bearer auth, don't attempt cookie refresh.
    if (bearer) {
        return res;
    }

    if (!retryOn401 || res.status !== 401 || shouldSkipRefresh(input) || !API_BASE_OPERATOR) {
        return res;
    }

    const refreshRes = await fetch(`${API_BASE_OPERATOR}/login/refresh`, {
        method: "POST",
        credentials: "include",
    });

    if (!refreshRes.ok) {
        return res;
    }

    return fetch(input, {
        ...init,
        credentials: "include",
    });
}
